<template>
  <thead
    class="sheet-head"
    v-if="moduleColumns"
  >
    <tr>
      <th colspan="2"></th>
      <th
        v-if="moduleColumns.metaElements.length"
        class="desc-cell"
        :colspan="moduleColumns.metaElements.length"
      >
      </th>
      <th
        v-if="moduleColumns.fixedElements.length"
        :colspan="moduleColumns.fixedElements.length"
        class="fixed-cell"
      >
      </th>
      <th
        v-if="moduleColumns.hourlyElements.length"
        :colspan="showHourlyElements.length"
        class="hourly-cell"
      >
        <span class="hourly-cell-title">
          <img src="/images/Hours-Blue.svg"></img>
          <p class="text-600 ml-5">HOURLY</p>
          <p v-if="!$store.getters.tokenData.email" @click="addHourly()" class="ml-20">+ Add New</p>
        </span>
      </th>
      <th
        v-if="moduleColumns.percentTasks.length"
        :colspan="showPercentTasks.length"
        class="hourly-cell percent-cell"
      >
        <span class="hourly-cell-title">
          <img src="/images/Percentage-Blue.svg"></img>
          <p class="text-600 ml-5">VARIABLE</p>
          <p v-if="!$store.getters.tokenData.email" @click="addPercent()" class="ml-20">+ Add New</p>
        </span>
      </th>
    </tr>
    <tr>
      <th colspan="2"></th>
      <th
        v-for="(item, key) in moduleColumns.metaElements"
        :key="key+'meta'"
        class="desc-cell text-nowrap"
      >
        <span class="text-nowrap">{{ item.name }}</span>
      </th>
      <th
        v-for="(item, key) in moduleColumns.fixedElements"
        :key="key+'fixed'"
        class="fixed-cell text-nowrap"
      >
        <span class="text-nowrap">{{ item.name }}</span>
      </th>
      <th
        v-for="(item, key) in moduleColumns.hourlyElements"
        :key="key+'hourly'"
        class="hourly-cell curg-cell"
        :class="{'disabled-column': item.disabled}"
        v-if="!item.hidden"
        draggable
        @dragover.prevent
        @dragenter="dragEnter($event, 'hourlyElements', key)"
        @drop="drop($event, 'hourlyElements', key)"
        @dragstart="dragStart($event, 'hourlyElements', key)"
        @dragend="dragEnd($event, 'hourlyElements', key)"
      >
        <img
          v-if="key>0 && moduleColumns.hourlyElements[key-1].hidden && !firsthidden('hourlyElements', key)"
          src="/images/ShowColumn.svg"
          class="hidden-column-left"
          @click="showLeftColumns('hourlyElements', key)"
        >
        <img
          v-if="firsthidden('hourlyElements', key)"
          src="/images/quote-arrow.svg"
          class="hidden-column-left hidden-column-left-first"
          @click="showFirstColumns('hourlyElements', key)"
        >
        <img
          v-if="lasthidden('hourlyElements', key)"
          src="/images/quote-arrow.svg"
          class="hidden-column-right always-show"
          @click="showLastColumns('hourlyElements', key)"
        >
        <p class="text-center curp text-nowrap">
          <img v-bind:src="item.taskImage" alt="" class="task-image-small">
          {{ item.name }}
        </p>
        <p class="text-center hourly-rate-override" v-if="item.hourlyRateOverride && (item.useTaskRate == true)">
          ${{ item.hourlyRateOverride }}/h
        </p>
        <img
          @click="openElementEdit(key+'hourly')"
          src="/images/mini-menu-icons/More-Icon-Hover.svg"
          class="more-img"
        />
        <PricingEditBox
          v-if="editItems[key+'hourly']"
          class="editbox"
          :item="item"
          @close="hideMenus()"
          @enable="columnActions('disableColumn', 'hourlyElements', key)"
          @hide="columnActions('hideColumn', 'hourlyElements', key)"
          @delete="columnActions('deleteColumn', 'hourlyElements', key)"
          @duplicate="columnActions('duplicateColumn', 'hourlyElements', key)"
          @clear="columnActions('clearColumn', 'hourlyElements', key)"
          @edit="editElement('hourlyElements', key)"
        >
        </PricingEditBox>
      </th>
      <th
        v-if="moduleColumns.percentTasks.length && !item.hidden"
        v-for="(item, key) in moduleColumns.percentTasks"
        :key="key+'percent'"
        class="hourly-cell percent-cell curg-cell"
        :class="{'disabled-column': item.disabled}"
        draggable
        @dragover.prevent
        @dragenter="dragEnter($event, 'percentTasks', key)"
        @drop="drop($event, 'percentTasks', key)"
        @dragstart="dragStart($event, 'percentTasks', key)"
        @dragend="dragEnd($event, 'percentTasks', key)"
      >
        <img
          v-if="key>0 && moduleColumns.percentTasks[key-1].hidden && !firsthidden('percentTasks', key)"
          src="/images/ShowColumn.svg"
          class="hidden-column-left"
          @click="showLeftColumns('percentTasks', key)"
        >
        <img
          v-if="firsthidden('percentTasks', key)"
          src="/images/quote-arrow.svg"
          class="hidden-column-left hidden-column-left-first"
          @click="showFirstColumns('percentTasks', key)"
        >
        <img
          v-if="lasthidden('percentTasks', key)"
          src="/images/quote-arrow.svg"
          class="hidden-column-right always-show"
          @click="showLastColumns('percentTasks', key)"
        >
        <p class="text-center curp text-nowrap">
          <img v-bind:src="item.taskImage" alt="" class="task-image-small">
          {{ item.name }}
        </p>
        <p class="text-center hourly-rate-override" v-if="item.hourlyRateOverride && (item.useTaskRate == true)">
          ${{ item.hourlyRateOverride }}/h
        </p>
        <img
          @click="openElementEdit(key+'percent')"
          src="/images/mini-menu-icons/More-Icon-Hover.svg"
          class="more-img"
        />
        <PricingEditBox
          v-if="editItems[key+'percent']"
          class="editbox"
          :item="item"
          @close="hideMenus()"
          @enable="columnActions('disableColumn', 'percentTasks', key)"
          @hide="columnActions('hideColumn', 'percentTasks', key)"
          @delete="columnActions('deleteColumn', 'percentTasks', key)"
          @duplicate="columnActions('duplicateColumn', 'percentTasks', key)"
          @clear="columnActions('clearColumn', 'percentTasks', key)"
          @edit="editElement('percentTasks', key)"
        >
        </PricingEditBox>
      </th>
    </tr>
  </thead>
</template>

<script>
import PricingEditBox from './PricingEditBox'
import { mapGetters } from 'vuex';

export default {
  name: 'PricingSheetHead',
  data () {
    return {
      staticImgPath: "/images/",
      editItems: {},
      draggingItem: null,
      draggingEnterItem: null
    }
  },
  components: {
    PricingEditBox
  },
  methods: {
    editElement(type, index) {
      this.hideMenus()
      this.$emit('editElement', { type, index })
    },
    addHourly() {
      this.$store.dispatch('addHourlyColumn', {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid
      })
    },
    addPercent() {
      this.$store.dispatch('addPercentColumn', {
        projectid: this.$route.params.projectid
      })
    },
    openElementEdit(key) {
      if (this.editItems[key]) {
        this.editItems = {}
      } else {
        this.editItems = {}
        this.editItems[key] = true
      }
    },
    columnActions(action, section, index) {
      this.hideMenus()
      this.$store.dispatch(action, {
        phases: this.currentProjectPhases,
        projectid: this.projectId,
        section: section,
        index: index
      })
    },
    hideMenus() {
      this.editItems = {}
    },
    showLeftColumns(section, index) {
      const showIndexes = []
      for (var i = index-1; i >= 0; i--) {
        if (!this.moduleColumns[section][i].hidden) {
          break
        }
        showIndexes.push(i)
      }
      this.$store.dispatch('unhideColumns', {
        projectid: this.$route.params.projectid,
        section: section,
        components: showIndexes
      })
    },
    showLastColumns(section, index) {
      const showIndexes = []
      for (var i = index+1; i < this.moduleColumns[section].length ; i++) {
        showIndexes.push(i)
      }
      this.$store.dispatch('unhideColumns', {
        projectid: this.$route.params.projectid,
        section: section,
        components: showIndexes
      })
    },
    showFirstColumns(section, index) {
      const showIndexes = []
      for (var i = 0; i < index ; i++) {
        showIndexes.push(i)
      }
      this.$store.dispatch('unhideColumns', {
        projectid: this.$route.params.projectid,
        section: section,
        components: showIndexes
      })
    },

    lasthidden (section, index) {
      if (index == this.moduleColumns[section].length-1) {
        return false
      }
      return this.moduleColumns[section]
        .slice(index+1, this.moduleColumns[section].length)
        .every(col => col.hidden)
    },
    firsthidden (section, index) {
      if (index == 0) { return false }
      return this.moduleColumns[section]
        .slice(0, index)
        .every(col => col.hidden)
    },
    dragEnter(e, section, index) {
      this.draggingEnterItem = { section, index }
    },
    drop(e, section, index) {
    },
    dragStart(e, section, index) {
      this.draggingItem = {section, index}
    },
    dragEnd(e, section, index) {
      if (this.draggingEnterItem && this.draggingEnterItem.section === section) {
        const data = {
          projectid: this.$route.params.projectid,
          section: section,
          from: index,
          to: this.draggingEnterItem.index
        }
        this.$store.dispatch('moveColumn', data).then(() => {
          this.draggingItem = null
          this.draggingEnterItem = null
        })
      } else {
        this.draggingItem = null
        this.draggingEnterItem = null
      }
    }
  },
  computed: {
    ...mapGetters(['currentProjectModuleColumns', 'currentProjectPhases']),
    moduleColumns() {
      let moduleColumns = this.currentProjectModuleColumns
      if (moduleColumns) {
        moduleColumns.metaElements = moduleColumns.metaElements || []
        moduleColumns.fixedElements = moduleColumns.fixedElements || []
        moduleColumns.hourlyElements = moduleColumns.hourlyElements || []
        moduleColumns.percentTasks = moduleColumns.percentTasks || []
      }
      return moduleColumns;
    },
    projectId() {
      return this.$route.params.projectid
    },
    showHourlyElements() {
      return this.moduleColumns.hourlyElements.filter(el => !el.hidden)
    },
    showPercentTasks() {
      return this.moduleColumns.percentTasks.filter(el => !el.hidden)
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
@import "../../../../styles/components/_pricingsheet.scss";
</style>
